import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"#E5E7EB\" d=\"M0 8.5a8 8 0 1 1 16 0 8 8 0 0 1-16 0\"></path><path fill=\"#6B7280\" d=\"m10.5 6-5 5z\"></path><path stroke=\"#6B7280\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m10.5 6-5 5\"></path><path fill=\"#6B7280\" d=\"m5.5 6 5 5z\"></path><path stroke=\"#6B7280\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m5.5 6 5 5\"></path>", 5)
  ]))]))
}
export default { render: render }